import { render } from "./CarouselComp.vue?vue&type=template&id=78138f53"
import script from "./CarouselComp.vue?vue&type=script&lang=js"
export * from "./CarouselComp.vue?vue&type=script&lang=js"

import "./CarouselComp.vue?vue&type=style&index=0&id=78138f53&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__